import { render, staticRenderFns } from "./PayPlanVersionPaneConnected.vue?vue&type=template&id=1badb3e6&scoped=true"
import script from "./PayPlanVersionPaneConnected.vue?vue&type=script&setup=true&lang=js"
export * from "./PayPlanVersionPaneConnected.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayPlanVersionPaneConnected.vue?vue&type=style&index=0&id=1badb3e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1badb3e6",
  null
  
)

export default component.exports